<template>
    <div class="mv-iframe-container">
      <iframe
        class="mv-iframe-responsive"
        width="100%"
        :style="{'height': iframeHeight}"
        :src="facebookLiveUrl()"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
</template>
<script>
import { getFacebookLiveEmbedUrl } from "@/helpers";
import i18n from "@/i18n";
export default {
  name: "FacebookLive",
  props: {
    meta: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.showNotification()
  },
  computed: {
      iframeHeight() {
        // const isFullScreenWithEmbed = this.meta.isEmbedMode && this.meta.isFullScreenMode
        return this.meta.isFullScreenMode ? '98vh' :'600px'
      }
    },
  methods: {
    facebookLiveUrl(autoplay = true) {
      return getFacebookLiveEmbedUrl(this.meta.content, autoplay);
    },

    /** Show notification: Event is about to start */
    showNotification() {
      this.$store.dispatch("app/showSupportNotification", {
        screener_id: this.meta.screener_id,
        message: this.meta.title + i18n.t("screener.meeting.is_about_to_stream")
      });
    }
  },
};
</script>
<style scoped>
    .mv-iframe-container {
        position: relative;
        width: 100%;
        overflow: hidden;
        padding-top: 57.25%; /* 16:9 Aspect Ratio */
    }
    .mv-iframe-responsive {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        border: none;
    }

</style>
